import {useMutation} from "@tanstack/react-query";

import {deleteRepresentativeMutationOptions} from "./delete-representative.mutation-options";

export function useDeleteRepresentative() {
  return useMutation(deleteRepresentativeMutationOptions());
}
